import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { MaterialIcon } from '../../../../components/MaterialIcon';
import { Dialog } from '../../../../components/Dialog';
import { DialogHeader } from '../../../../components/DialogHeader';
import { DialogBody } from '../../../../components/DialogBody';
import { DialogFooter } from '../../../../components/DialogFooter';
import { Button } from '../../../../components/Button';
import FeedbackCard from '../../../../components/FeedbackCard';

const Delete = ({ data, closeDialog, onDelete }) => {
    const [loading, setLoading] = useState('');
    const [deleteData, setDeleteData] = useState({});
    const [fatalError, setFatalError] = useState(null);

    useEffect(() => {
        if (loading === '') {
            setDeleteData(data);
        }
    });

    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const Delete = () => {
        setLoading('loading');
        onDelete()
            .then((resp) => {
                setLoading('success');
                setTimeout(() => {
                    setLoading('');
                    CloseDialog();
                }, 500);
            })
            .catch((e) => {
                setFatalError(e);
                setLoading('');
            });
    };

    return (
        <div style={{ height: `30rem` }}>
            <Dialog
                close={CloseDialog}
                size="md"
                visible
                id="node-manager-addEdit"
            >
                <DialogHeader
                    close={CloseDialog}
                >{`Delete ${deleteData.attributeName} - ${deleteData.nodePath}`}</DialogHeader>
                <DialogBody>
                    Are you sure you wish to delete this input node?
                    {fatalError != null && (
                        <FeedbackCard
                            intent={'danger'}
                            feedback={{
                                heading: `An error has occurred.`,
                                message: `Please wait a few moments before trying your request
        again.`
                            }}
                            details={fatalError}
                        />
                    )}
                </DialogBody>
                <DialogFooter>
                    {loading === 'loading' && (
                        <div style={{ marginRight: '0.5rem' }}>Loading...</div>
                    )}
                    {loading === 'success' && (
                        <div style={{ marginRight: '0.5rem' }}>
                            <MaterialIcon
                                icon={'done_outline'}
                                color={'#04846D'}
                            />
                        </div>
                    )}
                    <Button
                        appearance="primary"
                        text
                        onClick={Delete}
                        disabled={loading !== ''}
                    >
                        Delete
                    </Button>
                    <Button appearance="secondary" text onClick={CloseDialog}>
                        Cancel
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
};

Delete.propTypes = {
    onDelete: PropTypes.func.isRequired,
    data: PropTypes.object,
    closeDialog: PropTypes.func.isRequired
};

export default Delete;
